import { Loader } from "@googlemaps/js-api-loader";

const GooglePlacesPort = {
  add: function (app, googleMapsKey) {
    if (!googleMapsKey) {
      throw new Error("Google Maps Key is not configured.");
    }

    const loader = new Loader({
      apiKey: googleMapsKey,
      libraries: ["places"],
    });

    const fetchAutocompleteSuggestions = (id, request, callback) => {
      google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request)
        .then(({ suggestions }) => {
          const formattedSuggestions = suggestions.map((s) => {
            const p = s.placePrediction;

            return {
              description: p.text.text,
              place_id: p.placeId,
              types: p.types,
            };
          });

          callback({ suggestions: formattedSuggestions, id });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    loader
      .load()
      .then(() => {
        app.ports.googlePlacesPredictAddress.subscribe(function ({ address, id }) {
          if (!address) {
            return;
          }
          let sessionToken = new google.maps.places.AutocompleteSessionToken();

          let request = {
            input: address,
            sessionToken,
          };

          navigator.geolocation.getCurrentPosition(
            ({ coords: { latitude, longitude } }) => {
              fetchAutocompleteSuggestions(
                id,
                { ...request, locationBias: { radius: 5000, center: { lat: latitude, lng: longitude } } },
                app.ports.googlePlacesAddressSuggestions.send,
              );
            },
            () => {
              fetchAutocompleteSuggestions(id, request, app.ports.googlePlacesAddressSuggestions.send);
            },
          );
        });

        app.ports.googlePlacesPredictionDetails.subscribe(function ({ placeId, id }) {
          const place = new google.maps.places.Place({ id: placeId });

          place
            .fetchFields({
              fields: ["addressComponents", "formattedAddress", "displayName", "id", "types"],
            })
            .then((response) => {
              const transformedPlace = {
                address_components: (response.place.addressComponents || []).map((component) => ({
                  long_name: component.longText,
                  short_name: component.shortText,
                  types: component.types,
                })),

                formatted_address: response.place.formattedAddress,
                name: response.place.displayName,
                place_id: response.place.id,
                types: response.place.types,
              };

              const address = JSON.stringify(transformedPlace);
              app.ports.googlePlacesAddressDetails.send({ address, id });
            })
            .catch((error) => {
              console.log("Error fetching place details:", error);
              app.ports.googlePlacesAddressDetails.send({ address: null, id });
            });
        });
      })
      .catch((error) => console.log(error));
  },
};

module.exports = GooglePlacesPort;
